import { isOnlyWhitespace } from './is-only-whitespace';

export const hasTextContent = (node: Node): boolean => {
  return node?.parentNode !== null && !isOnlyWhitespace(node.textContent);
};
